import { Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton, CenteredSpinner } from '~/commonComponents';
import { usePostPermanentJobMutation } from '~/domain/Jobs';
import logoDarkIcon from '../../../images/logos/logoDarkIcon.svg';
import PPView from './PPView';

export default function PPScreen() {
  const { mutate: postPermanentJob, isPending } = usePostPermanentJobMutation();

  if (isPending) {
    return (
      <Screen variant="standard">
        <Screen.Body>
          <CenteredSpinner minHeight={400} />
        </Screen.Body>
      </Screen>
    );
  }
  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <img src={logoDarkIcon} style={{ width: 40 }} alt="GoTu" />
          <Typography size="heading_2" bold textAlign="center" color={colors.neutral[600]}>
            Permanent Hire
          </Typography>
          <Typography variant="body1" textAlign="center" color={colors.neutral[600]}>
            GoTu now offers a turn-key recruiting service to help you fill your open positions fast.
          </Typography>
        </div>
      </Screen.Header>
      <Screen.Body>
        <PPView
          btnSubmitClicked={(jobData) => postPermanentJob(jobData)}
          isSubmitting={isPending}
        />
      </Screen.Body>
    </Screen>
  );
}
